import { render } from "./H2H.vue?vue&type=template&id=3497ec14&scoped=true"
import script from "./H2H.vue?vue&type=script&lang=js"
export * from "./H2H.vue?vue&type=script&lang=js"

import "./H2H.vue?vue&type=style&index=0&id=3497ec14&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3497ec14"]])

export default __exports__